import React, { useState, useEffect } from 'react';
import { usePlanFeatures } from '../../contexts/PlanFeaturesContext';
import Dropdown from '../dropdown/dropdown';
import hazardIcon from '../../images/hazardIcon.svg';
import './styles.css';


const PlanSelector = ({ onPlanChange, showPlanError = false, selectedPlan, setSelectedPlan }) => {
    const { planFeatures, loading: planFeaturesLoading } = usePlanFeatures();

    // Only show if more than one plan
    // API returns planType for long names, planCode for codes
    const planTypes = planFeatures?.planType || planFeatures?.planName || [];
    const planCodes = planFeatures?.planCode || [];
    
    const availablePlans = (Array.isArray(planTypes) && planTypes.length > 1)
        ? planTypes.map((planTypeName, index) => ({
            name: planTypeName,
            code: planCodes[index] || '',
            value: planCodes[index] || '' // Use planCode as value
        }))
        : [];

    if (planFeaturesLoading) {
        return (
            <div className="plan-selector-container">
                <div className="plan-selector-title">Loading plans...</div>
            </div>
        );
    }

    if (availablePlans.length === 0) {
        return null;
    }

    const dropdownClasses = `plan-dropdown ${showPlanError ? 'error' : 'mb30'}`;

    const handlePlanChange = (e) => {
        const value = e.target.value;
        console.log('🎯 PlanSelector - Plan selected:', value);
        console.log('   Available plans:', availablePlans);
        setSelectedPlan(value);
        if (onPlanChange) {
            onPlanChange(value);
        }
    };

    return (
        <div className="plan-selector-container">
            <label htmlFor="plan-select" className="plan-selector-title">
                Choose a plan (required)
            </label>
            <Dropdown
                id="plan-select"
                className={dropdownClasses}
                value={selectedPlan}
                onChange={handlePlanChange}
                aria-required="true"
                aria-describedby={showPlanError ? 'plan-error-msg' : undefined}
            >
                <option value="">Choose one option</option>
                {availablePlans.map((plan, index) => (
                    <option key={`plan-${index}-${plan.value}`} value={plan.value}>
                        {plan.name}
                    </option>
                ))}
            </Dropdown>
            {showPlanError && (
                <div id="plan-error-msg" className="plan-error-message" role="alert">
                    <img src={hazardIcon} alt="" className="error-icon" />
                    <span>Be sure to choose a plan.</span>
                </div>
            )}
        </div>
    );
};

export default PlanSelector;
